import React from "react";
import { Navigate, Route } from "react-router-dom";

import CertidoesDocumentosLayout from "../pages/Templates/Template-Administrativo/Governanca/CertidoesDocumentos/CertidoesDocumentosLayout-v2";
import PortaisClientesLayout from "../pages/Templates/Template-Administrativo/Governanca/PortaisClientes/GovernancaPortaisClientesLayout";


export const governancaCertidoesRoutes = (
  <>
    {/* Caminho principal que o LeftBar tende a gerar pelo label do módulo */}
    <Route
      path="/governanca-qualidade-e-compliance/certidoes-e-documentos"
      element={
        <Navigate
          to="/governanca-qualidade-e-compliance/certidoes-e-documentos/visao-geral"
          replace
        />
      }
    />

    <Route
      path="/governanca-qualidade-e-compliance/certidoes-e-documentos/visao-geral"
      element={<CertidoesDocumentosLayout section="visao-geral" />}
    />

    <Route
      path="/governanca-qualidade-e-compliance/certidoes-e-documentos/a-vencer"
      element={<CertidoesDocumentosLayout section="a-vencer" />}
    />

    <Route
      path="/governanca-qualidade-e-compliance/certidoes-e-documentos/vencidas"
      element={<CertidoesDocumentosLayout section="vencidas" />}
    />

    <Route
      path="/governanca-qualidade-e-compliance/certidoes-e-documentos/anexados"
      element={<CertidoesDocumentosLayout section="anexados" />}
    />

    <Route
      path="/governanca-qualidade-e-compliance/certidoes-e-documentos/historico"
      element={<CertidoesDocumentosLayout section="historico" />}
    />

    {/* Compatibilidade com os códigos atuais dos submódulos no banco */}
    <Route
      path="/governanca-qualidade-e-compliance/certidoes-e-documentos/governanca-certidoes-visao-geral"
      element={<CertidoesDocumentosLayout section="visao-geral" />}
    />

    <Route
      path="/governanca-qualidade-e-compliance/certidoes-e-documentos/governanca-certidoes-a-vencer"
      element={<CertidoesDocumentosLayout section="a-vencer" />}
    />

    <Route
      path="/governanca-qualidade-e-compliance/certidoes-e-documentos/governanca-certidoes-vencidas"
      element={<CertidoesDocumentosLayout section="vencidas" />}
    />

    <Route
      path="/governanca-qualidade-e-compliance/certidoes-e-documentos/governanca-documentos-anexados"
      element={<CertidoesDocumentosLayout section="anexados" />}
    />

    <Route
      path="/governanca-qualidade-e-compliance/certidoes-e-documentos/governanca-certidoes-historico-evidencias"
      element={<CertidoesDocumentosLayout section="historico" />}
    />

    {/* Compatibilidade com o caminho que você tinha planejado no SQL */}
    <Route
      path="/governanca-qualidade-e-compliance/certidoes-documentos"
      element={
        <Navigate
          to="/governanca-qualidade-e-compliance/certidoes-e-documentos/visao-geral"
          replace
        />
      }
    />

    <Route
      path="/governanca-qualidade-e-compliance/certidoes-documentos/visao-geral"
      element={<CertidoesDocumentosLayout section="visao-geral" />}
    />

    <Route
      path="/governanca-qualidade-e-compliance/portais-de-clientes"
      element={<PortaisClientesLayout />}
    />

    <Route
      path="/governanca-qualidade-e-compliance/certidoes-documentos/a-vencer"
      element={<CertidoesDocumentosLayout section="a-vencer" />}
    />

    <Route
      path="/governanca-qualidade-e-compliance/certidoes-documentos/vencidas"
      element={<CertidoesDocumentosLayout section="vencidas" />}
    />

    <Route
      path="/governanca-qualidade-e-compliance/certidoes-documentos/anexados"
      element={<CertidoesDocumentosLayout section="anexados" />}
    />

    <Route
      path="/governanca-qualidade-e-compliance/certidoes-documentos/historico"
      element={<CertidoesDocumentosLayout section="historico" />}
    />

   
  </>
);
